var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-element',_vm._g(_vm._b({},'form-element',_vm.$props,false),_vm.$listeners),[_c('search-contact',{attrs:{"on-create":_vm.onCreate,"on-edit":_vm.onEdit},model:{value:(_vm.searchedContact),callback:function ($$v) {_vm.searchedContact=$$v},expression:"searchedContact"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }